import { Navigate } from "react-router-dom";
import useAuth from "./supabaseAuth";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return <div>Loading...</div>; // Optional: Add a spinner here

  return user ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
